import useCurrentMember from '@/member/hooks/useCurrentMember'
import { useOrgContext } from '@/org/contexts/OrgContext'
import { MemberSummaryFragment } from '@gql'
import { SearchTypes } from '@rolebase/shared/model/search'
import { useMemo } from 'react'
import { SearchItem } from '../searchTypes'

// MemberSummaryFragment and not MemberFragment (11/08): this hook only reads
// id, name and picture, all of which the short fragment carries. Asking for the
// long one forced callers assembling members from several sources — role
// holders and circle participants, which do not share a shape — to fall back on
// `any`. The type now says what is actually needed.
export function useMemberSearchItems(
  members?: MemberSummaryFragment[], // If not provided, use store
  excludeIds?: string[]
): SearchItem[] {
  const currentMember = useCurrentMember()
  const membersInStore = useOrgContext().orgData?.members

  return useMemo(
    () =>
      ((members || membersInStore)
        ?.map((member): SearchItem | undefined => {
          // Exclude by id
          if (excludeIds?.includes(member.id)) return

          return {
            id: member.id,
            text: member.name.toLowerCase(),
            type: SearchTypes.Member,
            title: member.name,
            picture: member.picture || undefined,
          }
        })
        .filter(Boolean) as SearchItem[]) || [],
    [members, membersInStore, excludeIds, currentMember]
  )
}
